import BaseModel from './base';

class AdyenModel extends BaseModel {
	async savePayment({ currency, handlerData = {} }) {
		return this.post('/save-payment-method', {
			body: {
				currency,
				handlerData
			}
		});
	}

	async redirectResult({ handlerData = {} }) {
		return this.post('/handle-redirect-result', {
			body: {
				handlerData
			}
		});
	}
}

export default new AdyenModel('/adyen');
